import { BaseRequest } from "../base-request.model";

export class downloadfile extends BaseRequest{
    ID:number;
    idsList: string;
}
